import { useCallback, useState } from "react";
import type { ErrorDetails } from "../components/notification/ErrorNotification";

type ErrorWithKey = ErrorDetails & {
    key: string;
};

export const useErrorNotification = () => {
    const [errors, setErrors] = useState<ErrorWithKey[]>([]);

    const showError = useCallback((title: string, errorOrResponse?: any) => {
        let errorDetails: ErrorDetails = { title };

        if (errorOrResponse instanceof Response) {
            errorDetails.message = `${errorOrResponse.status}: ${errorOrResponse.statusText}`;
            errorDetails.code = 'unknown';
            errorDetails.id = '----';

            errorOrResponse.json()
                .then((json) => {
                    if (json.message) errorDetails.message = json.message;
                    if (json.code) errorDetails.code = json.code;
                    if (json.id) errorDetails.id = json.id;
                })
                .catch(() => {
                });
        } else if (errorOrResponse instanceof Error) {
            errorDetails.message = errorOrResponse.message;
            errorDetails.code = errorOrResponse.name;
            errorDetails.id = '----';
        } else if (errorOrResponse && typeof errorOrResponse === 'object') {
            if (errorOrResponse.responseJSON) {
                const json = errorOrResponse.responseJSON;
                errorDetails.message = json.message || JSON.stringify(json);
                errorDetails.code = json.code || `${errorOrResponse.statusText || 'unknown'}(${errorOrResponse.status || 'unknown'})`;
                errorDetails.id = json.id || '----';
            } else {
                errorDetails.message = errorOrResponse.message || JSON.stringify(errorOrResponse);
                errorDetails.code = errorOrResponse.code || 'unknown';
                errorDetails.id = errorOrResponse.id || '----';
            }
        }

        console.error(`${title}\n${errorDetails.message || ''}`);

        const newError: ErrorWithKey = {
            ...errorDetails,
            key: `error-${Date.now()}-${Math.random()}`,
        };

        setErrors((prev) => [...prev, newError]);
    }, []);

    const showSimpleError = useCallback((title: string) => {
        console.error(title);

        const newError: ErrorWithKey = {
            title,
            key: `error-${Date.now()}-${Math.random()}`,
        };

        setErrors((prev) => [...prev, newError]);
    }, []);

    const removeError = useCallback((key: string) => {
        setErrors((prev) => prev.filter((error) => error.key !== key));
    }, []);

    const clearErrors = useCallback(() => {
        setErrors([]);
    }, []);

    return {
        errors,
        showError,
        showSimpleError,
        removeError,
        clearErrors,
    };
}

export default useErrorNotification;
